module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hO0gU"))).then(() => parcelRequire('ljYL6'));